var LAND_DETAILS_CONTROL_CHECK_INTERVAL = 15; // in milliseconds

// When we want to change the layer, this function continue to check
// whether the control is ready or not. Once ready the layer is updated.
// The frequency of checking is defined in constant
// LAND_DETAILS_CONTROL_CHECK_INTERVAL
export var changeLayerWhenPossible = _ref => {
  var layerKey = _ref.layerKey,
    isSchool = _ref.isSchool,
    landDetailsControl = _ref.landDetailsControl;
  window.landDetailsControlRetries = 0;
  if (window.landDetailsControlInterval) {
    clearInterval(window.landDetailsControlInterval);
  }
  window.landDetailsControlInterval = setInterval(() => {
    window.landDetailsControlRetries += 1;
    if (landDetailsControl && landDetailsControl.current) {
      landDetailsControl.current.updateOverlay(layerKey, isSchool);
      if (isSchool) {
        landDetailsControl.current.updateSchools(layerKey);
      }
      clearInterval(window.landDetailsControlInterval);
      window.landDetailsControlInterval = null;
      window.landDetailsControlRetries = null;
    }
    if (window.landDetailsControlRetries >= 1500) {
      clearInterval(window.landDetailsControlInterval);
      window.landDetailsControlRetries = null;
    }
  }, LAND_DETAILS_CONTROL_CHECK_INTERVAL);
};
export default changeLayerWhenPossible;